import React from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import './bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <>
      <main>
        <Container fluid>
          <Outlet />
        </Container>
      </main>
      <ToastContainer />
    </>
  )
};

export default App;
